import React from "react";
import "./MessageBanner.scss";

const MessageBanner = ({ message, type = "info", onClose }) => {
  if (!message) return null;

  return (
    <div className={`message-banner ${type}`}>
      <span className="message-text">{message}</span>
      {onClose && (
        <button className="close-button" onClick={onClose} title="Dismiss">
          &times;
        </button>
      )}
    </div>
  );
};

export default MessageBanner;
